import { useState, useEffect, useMemo } from 'react';
import { getCorporateGroups } from '../../api';
export const useCorporateGroups = (isOpen) => {
    const [corporateGroups, setCorporateGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchCorporateGroups = async () => {
            try {
                setLoading(true);
                const response = await getCorporateGroups();
                if (response.body && response.body.success) {
                    setCorporateGroups(response.body.data);
                }
            }
            catch (err) {
                console.error('Error fetching corporate groups:', err);
            }
            finally {
                setLoading(false);
            }
        };
        if (isOpen) {
            fetchCorporateGroups();
        }
    }, [isOpen]);
    return { corporateGroups, loading };
};
export const useFuzzySearch = (items, searchTerm) => {
    return useMemo(() => {
        if (!searchTerm.trim())
            return items;
        const search = searchTerm.toLowerCase().trim();
        return items.filter((item) => {
            const name = item.name.toLowerCase();
            const abbreviation = (item.abbreviation || '').toLowerCase();
            if (name === search || abbreviation === search)
                return true;
            if (name.startsWith(search) || abbreviation.startsWith(search))
                return true;
            if (name.includes(search) || abbreviation.includes(search))
                return true;
            const nameWords = name.split(' ');
            return nameWords.some((word) => word.startsWith(search) || word.includes(search));
        });
    }, [items, searchTerm]);
};
